'use client';

import useParamsEditor from '@/src/utils/useParamsEditor';
import Modal from '../Modal';
import InfoConfirmationForm from './InfoConfirmationForm';
import { useSearchParams } from 'next/navigation';

export default function InfoConfirmationModal() {
  const searchParams = useSearchParams();
  const showValidationForm = searchParams.get('customer_key');
  const editParam = useParamsEditor();
  const customClose = () => {
    editParam('customer_key');
  };

  return (
    showValidationForm && (
      <Modal customClose={customClose} backgroundClose={false}>
        <InfoConfirmationForm />
      </Modal>
    )
  );
}
